<template>

    <div>


      <!-- KtDatatable Implementation -->
      <kt-datatable
          :model="requestModel"
          :data="rows"
          :filter="datatableFilter"
          :meta="{ tableClass: '-table-bordered', rowClass: (row) => getRowClass(row) }"
          :update-function="handleDatatableUpdate"
          :hide-search="false"
          @cell-click="handleCellClick"
          storage-key="job-list"
      >
        <template #header_select="scope">
          <div class="form-check">
            <input 
              class="form-check-input" 
              type="checkbox" 
              :checked="selectAll"
              @change="toggleSelectAll"
              @click.stop
              title="Select all on this page"
            />
          </div>
        </template>
        
        <template #view_select="scope">
          <div class="form-check">
            <input 
              class="form-check-input" 
              type="checkbox" 
              :checked="selectedRows.includes(scope.row.Id)"
              @change="toggleRowSelection(scope.row.Id)"
              @click.stop
            />
          </div>
        </template>
        
        <template #filters="scope">
          <!-- <client-multi :label="''"></client-multi> -->
           <div class="col">
            <div class="row">
                <div class="col-auto">
                    <client-multi-check 
                        label="Clients"
                        :model-value="currentFilter.client"
                        @update:model-value="(value) => setFilter({client: value})"
                    ></client-multi-check>
                </div>
                <div class="col-auto">
                    <tech-multi-check 
                        label="Technicians"
                        :model-value="currentFilter.technician"
                        @update:model-value="(value) => setFilter({technician: value})"
                    ></tech-multi-check>
                </div>
                <div class="col-auto">
                    <job-status-multi-check 
                        label="Status"
                        :model-value="currentFilter.status"
                        @update:model-value="(value) => setFilter({status: value})"
                    ></job-status-multi-check>
                </div>
                <div class="col-auto">
                    <kt-date-range-select
                        label="Date Range"
                        v-model="dateRange"
                        @change="handleDateRangeChange"
                    ></kt-date-range-select>
                </div>
            </div>
           </div>
        </template>

        <template #after-search="scope">
            <div class="-btn-group">
          <button @click="refresh()" 
              class="btn btn-sm btn-outline-secondary me-2"
          >Refresh <i class="fa fa-sync"></i></button>

          <button @click="newRecord()" 
              class="btn btn-sm btn-outline-primary"
          >New <i class="fa fa-plus"></i></button>
          </div>
        </template>

        <template #view_string="scope">
          <span v-if="scope.column.name === 'Contact'">
            <a href="javascript:void(0);" @click="editContact(scope.row.Contact?.Id)">
              {{ scope.row.Contact?.Company || 'N/A' }}
            </a>
          </span>
          <span v-else-if="scope.column.name === 'RequestStatus'">
            <span :class="getStatusBadgeClass(scope.row.RequestStatus)" class="badge">
              <i :class="getStatusIcon(scope.row.RequestStatus)" class="me-1"></i>
              {{ JobStatusList[scope.row.RequestStatus]?.Status || 'N/A' }}
            </span>
          </span>
          <span v-else-if="scope.column.name === 'Technician'">
            <a href="javascript:void(0);" @click="editTech(TechList[scope.row.Technician]?.Id)">
                {{ TechList[scope.row.Technician]?.TechnicianName || 'N/A' }}
            </a>
          </span>
          <span v-else-if="scope.column.name === 'RequestDetailedDescription'">
            <a href="javascript:void(0);" @click="editRecord(scope.row.Id)">
                {{ scope.row.RequestDetailedDescription || 'N/A' }}
            </a>
          </span>
          <span v-else-if="scope.column.name === 'Id'">
            <a href="javascript:void(0);" @click="editRecord(scope.row.Id)">
                {{ scope.row.Id }}
            </a>
          </span>
          <span v-else>
              {{ scope.value }}
          </span>
        </template>

        <template #view_number="scope">
          <span v-if="scope.column.name === 'Priority'">
            <span :class="getPriorityBadgeClass(scope.row.Priority)" class="badge">
              {{ PriorityList[scope.row.Priority]?.Level || scope.row.Priority || 'N/A' }}
            </span>
          </span>
          <span v-else>
            {{ scope.value }}
          </span>
        </template>

        <!-- Bulk actions and filter badges in under-header slot -->
        <template #under-header>
          <!-- Bulk Actions Toolbar -->
          <div v-if="selectedRows.length > 0" class="mb-0 p-2 actions-row">
            <div class="d-flex align-items-center gap-2">
              <span class="fw-bold text-primary">{{ selectedRows.length }} selected</span>
              <button 
                class="btn btn-sm btn-outline-primary"
                @click="showSetDueDateModal = true"
                title="Set Due Date"
              >
                <i class="fas fa-clock"></i>
              </button>
              <button 
                class="btn btn-sm btn-outline-primary"
                @click="showAssignTechModal = true"
                title="Assign Technician"
              >
                <i class="fas fa-user"></i>
              </button>
              <button 
                class="btn btn-sm btn-outline-primary"
                @click="showSetStatusModal = true"
                title="Set Status"
              >
                <i class="fas fa-flag"></i>
              </button>
              <button 
                class="btn btn-sm btn-outline-primary"
                @click="showSetPriorityModal = true"
                title="Set Priority"
              >
                <i class="fas fa-info-circle"></i>
              </button>
              <button 
                class="btn btn-sm btn-outline-danger"
                @click="showDeleteModal = true"
                title="Delete"
              >
                <i class="fas fa-trash"></i>
              </button>
              <button 
                class="btn btn-sm btn-outline-secondary me-auto"
                @click="clearSelection"
              >
                Clear Selection
              </button>
            </div>
          </div>
          
          <!-- Filter Badges -->
          <div v-if="hasActiveFilters" class="d-flex flex-wrap gap-2 p-2">
            <span class="text-muted small me-2">Active filters:</span>
            
            <!-- Client badges -->
            <span v-for="clientId in currentFilter.client" :key="'client-' + clientId" 
                  class="badge bg-primary d-flex align-items-center">
              Client: {{ getClientName(clientId) }}
              <button type="button" class="btn-close btn-close-white ms-2" 
                      @click="removeClientFilter(clientId)"
                      style="font-size: 0.7em;"></button>
            </span>
            
            <!-- Technician badges -->
            <span v-for="techId in currentFilter.technician" :key="'tech-' + techId"
                  class="badge bg-secondary d-flex align-items-center">
              Technician: {{ getTechnicianName(techId) }}
              <button type="button" class="btn-close btn-close-white ms-2" 
                      @click="removeTechnicianFilter(techId)"
                      style="font-size: 0.7em;"></button>
            </span>
            
            <!-- Status badges -->
            <span v-for="statusId in currentFilter.status" :key="'status-' + statusId"
                  class="badge bg-info d-flex align-items-center">
              Status: {{ getStatusName(statusId) }}
              <button type="button" class="btn-close btn-close-white ms-2" 
                      @click="removeStatusFilter(statusId)"
                      style="font-size: 0.7em;"></button>
            </span>
            
            <!-- Date range badge -->
            <span v-if="currentFilter.startDate || currentFilter.endDate"
                  class="badge bg-secondary d-flex align-items-center">
              Date: {{ formatDateRange() }}
              <button type="button" class="btn-close btn-close-white ms-2" 
                      @click="removeDateFilter()"
                      style="font-size: 0.7em;"></button>
            </span>
            
            <!-- Search term badge -->
            <span v-if="currentFilter.searchTerm"
                  class="badge bg-secondary d-flex align-items-center">
              Search: {{ currentFilter.searchTerm }}
              <button type="button" class="btn-close btn-close-white ms-2" 
                      @click="setFilter({ searchTerm: '' })"
                      style="font-size: 0.7em;"></button>
            </span>
            
            <!-- Clear all filters -->
            <button v-if="hasActiveFilters" 
                    class="btn btn-sm btn-outline-secondary ms-0" 
                    @click="clearAllFilters()">
              Clear All
            </button>
          </div>
        </template>
      </kt-datatable>
      
      <!-- Bulk Action Modals -->
      
      <!-- Assign Technician Modal -->
      <kt-modal
        :visible="showAssignTechModal"
        title="Assign Technician"
        @dismiss="showAssignTechModal = false"
      >
        <template #body>
          <div class="container-fluid">
            <p class="text-muted mb-3">Assigning technician to {{ selectedRows.length }} request(s)</p>
            <tech-select
              label="Select Technician"
              v-model="bulkAssignTech"
              :active="1"
            ></tech-select>
          </div>
        </template>
        <template #footer>
          <button class="btn btn-secondary" @click="showAssignTechModal = false">Cancel</button>
          <button class="btn btn-primary" @click="applyBulkAssignTech" :disabled="!bulkAssignTech">Apply</button>
        </template>
      </kt-modal>
      
      <!-- Set Due Date Modal -->
      <kt-modal
        :visible="showSetDueDateModal"
        title="Set Due Date"
        @dismiss="showSetDueDateModal = false"
      >
        <template #body>
          <div class="container-fluid">
            <p class="text-muted mb-3">Setting due date for {{ selectedRows.length }} request(s)</p>
            <kt-input
              type="date"
              label="Due Date"
              v-model="bulkDueDate"
              :input-class="'form-control'"
            ></kt-input>
          </div>
        </template>
        <template #footer>
          <button class="btn btn-secondary" @click="showSetDueDateModal = false">Cancel</button>
          <button class="btn btn-primary" @click="applyBulkDueDate" :disabled="!bulkDueDate">Apply</button>
        </template>
      </kt-modal>
      
      <!-- Set Status Modal -->
      <kt-modal
        :visible="showSetStatusModal"
        title="Set Status"
        @dismiss="showSetStatusModal = false"
      >
        <template #body>
          <div class="container-fluid">
            <p class="text-muted mb-3">Setting status for {{ selectedRows.length }} request(s)</p>
            <label class="form-label">Select Status</label>
            <select class="form-select" v-model="bulkStatus">
              <option :value="null">-- Select Status --</option>
              <option v-for="status in JobStatusList" :key="status.Id" :value="status.Id">
                {{ status.Status }}
              </option>
            </select>
          </div>
        </template>
        <template #footer>
          <button class="btn btn-secondary" @click="showSetStatusModal = false">Cancel</button>
          <button class="btn btn-primary" @click="applyBulkStatus" :disabled="bulkStatus === null">Apply</button>
        </template>
      </kt-modal>
      
      <!-- Set Priority Modal -->
      <kt-modal
        :visible="showSetPriorityModal"
        title="Set Priority"
        @dismiss="showSetPriorityModal = false"
      >
        <template #body>
          <div class="container-fluid">
            <p class="text-muted mb-3">Setting priority for {{ selectedRows.length }} request(s)</p>
            <label class="form-label">Select Priority</label>
            <select class="form-select" v-model="bulkPriority">
              <option :value="null">-- Select Priority --</option>
              <option v-for="priority in PriorityList" :key="priority.Id" :value="priority.Id">
                {{ priority.Level }}
              </option>
            </select>
          </div>
        </template>
        <template #footer>
          <button class="btn btn-secondary" @click="showSetPriorityModal = false">Cancel</button>
          <button class="btn btn-primary" @click="applyBulkPriority" :disabled="bulkPriority === null">Apply</button>
        </template>
      </kt-modal>
      
      

        <!-- LIST MODAL
        <kt-modal
            title="Request List"
            :visible="1"
            @dismiss="dismiss()"
        >
    
            <template #body>

                <job-filter-row
                    @click="filterVisible = 1"
                    :total="total"
                    :filter="filter"
                    :count="rows.length"
                ></job-filter-row>

                <div class="container-fluid my-2 px-0">
                    <div class="row" v-if="2 < rows.length">
                        <div class="col-4">
                            <button @click="dismiss()" 
                                class="btn btn-secondary form-control"
                            >Close</button>
                        </div>
                        <div class="col-4">
                            <button @click="refresh()" 
                                class="btn btn-primary form-control"
                            >Refresh</button>
                        </div>
                        <div class="col-4">
                            <button @click="newRecord()"
                                class="btn btn-primary form-control"
                            >New</button>
                        </div>
                    </div>
                </div>

                

            </template>

            <template #footer>
                <div class="container-fluid px-0">
                    <div class="row">
                        <div class="col-4">
                            <button @click="dismiss()" 
                                class="btn btn-secondary form-control"
                            >Close</button>
                        </div>
                        <div class="col-4">
                            <button @click="refresh()" 
                                class="btn btn-primary form-control"
                            >Refresh</button>
                        </div>
                        <div class="col-4">
                            <button @click="newRecord()"
                                class="btn btn-primary form-control"
                            >New</button>
                        </div>
                    </div>
                </div>
            </template>
        </kt-modal>
        
        -->

        <kt-modal
            :visible="filterVisible"
            :title="filterTitle"
            @dismiss="filterVisible = 0"
        >
            <template #body>
                <job-filter
                    :filter="filter" 
                    @dismiss="filterVisible = 0" 
                    @update="setFilter($event)"
                ></job-filter>
            </template>
        </kt-modal>


        <router-view name="modal"></router-view>

    </div>
    
</template>

<script setup lang="ts">
import { ref, onMounted, watch, computed } from "vue";
import { useRouter, useRoute, RouterView } from 'vue-router';
import ClientMulti from "@/components/Clients/ClientMulti.vue";
import JobSelect from "@/components/Jobs/JobSelect.vue";
import JobFilter from "@/components/Jobs/JobFilter.vue";
import JobFilterRow from "@/components/Jobs/JobFilterRow.vue";
import Helper from "@/services/Helper";
import Cache from "@/services/Cache";
import Emitter from "@/services/Emitter";
import Api from "@/services/ApiService";
import Attic from "@/services/Attic.js";
import KtModal from '@/components/UI/KtModal.vue';
import KtDatatable from "@/components/UI/KtDatatable.vue";
import KtDropmenu from "@/components/UI/KtDropmenu.vue";
import { KtDatatableModelProp, KtDatatableData } from "@/components/UI/KtDataTable";

import { getActivePinia, storeToRefs } from "pinia";
import JobForm from "@/components/Jobs/JobForm.vue";
import ClientAc from "@/components/Clients/ClientAc.vue";

// stores ...
import { useClientStore } from '@/stores/ClientStore';
import { useJobStatusStore } from "@/stores/JobStatusStore";
import { useTechStore } from "@/stores/TechStore";
import { usePriorityStore } from "@/stores/PriorityStore";
import ClientMultiCheck from "@/components/Clients/ClientMultiCheck.vue";
import JobStatusMultiCheck from "@/components/Jobs/JobStatusMultiCheck.vue";
import TechMultiCheck from "@/components/Techs/TechMultiCheck.vue";
import KtDateRangeSelect from "@/components/UI/KtDateRangeSelect.vue";
import TechSelect from "@/components/Techs/TechSelect.vue";
import JobStatusAc from "@/components/Jobs/JobStatusAc.vue";
import KtInput from "@/components/UI/KtInput.vue";
import Alert from "@/services/Alert";

const jobStatusStore = useJobStatusStore();
const { list: JobStatusList } = storeToRefs(jobStatusStore);

const techStore = useTechStore();
const { list: TechList } = storeToRefs(techStore);

const clientStore = useClientStore();
const { list: ClientList } = storeToRefs(clientStore);

const priorityStore = usePriorityStore();
const { list: PriorityList } = storeToRefs(priorityStore);

// reload stores for now ... can this be moved into the useStore methods ?
jobStatusStore.reload();
techStore.reload();
clientStore.reload();
priorityStore.reload();

const router = useRouter();
const route = useRoute();
// const jobList = ref([]);

const statusList = ref(Attic.JobStatusList);
const total = ref(0);
const rows = ref<any[]>([]);

const handleCellClick = (row: any, column: any, value: any, rowIndex: number) => {
    // For now, edit record on any cell click (except Select column which has @click.stop)
    // You can add custom logic based on column.name or column.type here
    if (column.name !== 'Select') {
        editRecord(row.Id);
    } 
    
    else {
        toggleRowSelection(row.Id);
    }
};

// ===== NEW CLEAN FILTER SYSTEM =====

// Filter state interface
interface JobListFilter {
    client: number[];
    status: number[];
    technician: number[];
    user: string;
    searchTerm: string;
    startDate: string;
    endDate: string;
    page: number;
    size: number;
    sort: Array<Record<string, 'ASC' | 'DESC'>>;
}

// Current filter state (reactive)
const currentFilter = ref<JobListFilter>({
    client: [],
    status: [],
    technician: [],
    user: '',
    searchTerm: '',
    startDate: '',
    endDate: '',
    page: 0,
    size: 25,
    sort: []
});

// Datatable filter for pagination (derived from currentFilter)
const datatableFilter = computed(() => ({
    page: currentFilter.value.page,
    size: currentFilter.value.size,
    total: total.value,
    search: currentFilter.value.searchTerm,
    sort: currentFilter.value.sort
}));

// Date range picker (derived from currentFilter)
const dateRange = computed({
    get: () => ({
        startDate: currentFilter.value.startDate || null,
        endDate: currentFilter.value.endDate || null
    }),
    set: (value) => {
        // Use setFilter to maintain consistency with other components
        setFilter({
            startDate: value.startDate || '',
            endDate: value.endDate || ''
        });
    }
});

const handleDateRangeChange = (value: { startDate: string | null; endDate: string | null }) => {
    setFilter({
        startDate: value.startDate || '',
        endDate: value.endDate || ''
    });
};

const actionDropdown = ref<Record<string, boolean>>({});

// Selection state
const selectedRows = ref<number[]>([]);
const selectAll = ref(false);

// Bulk action modals
const showAssignTechModal = ref(false);
const showSetDueDateModal = ref(false);
const showSetStatusModal = ref(false);
const showSetPriorityModal = ref(false);
const showDeleteModal = ref(false);

// Bulk action values
const bulkAssignTech = ref<number | null>(null);
const bulkDueDate = ref<string>('');
const bulkStatus = ref<number | null>(null);
const bulkPriority = ref<number | null>(null);

// Legacy variables for existing filter components (will be updated later)
const filterVisible = ref(false);
const filterTitle = ref("Filter Request Entries");
const filter = computed(() => ({
    client: currentFilter.value.client.map(c => c.toString()).join(','),
    status: currentFilter.value.status.map(s => s.toString()).join(','),
    technician: currentFilter.value.technician.map(t => t.toString()).join(','),
    user: currentFilter.value.user,
    searchTerm: currentFilter.value.searchTerm,
    startDate: currentFilter.value.startDate,
    endDate: currentFilter.value.endDate,
    page: currentFilter.value.page.toString()
}));

// ===== URL & FILTER UTILITIES =====

// Parse sort parameter from URL string to KtDatatable sort array format  
const parseSortFromUrl = (sortParam?: string): Array<Record<string, 'ASC' | 'DESC'>> => {
    if (!sortParam) return [];
    
    // Parse comma-separated sort string like "Id,-CreateDate,PartCost"
    // Where "-" prefix means DESC, no prefix means ASC
    return sortParam.split(',').map(sortField => {
        const trimmed = sortField.trim();
        if (trimmed.startsWith('-')) {
            const column = trimmed.substring(1);
            return { [column]: 'DESC' as const };
        } else {
            return { [trimmed]: 'ASC' as const };
        }
    });
};

// Parse URL params to filter object
const parseUrlToFilter = (): JobListFilter => {
    // For hash router, get params from Vue Router instead of window.location
    const routeQuery = route.query;
    
    console.debug('Parsing URL params from route.query:', routeQuery);
    console.debug('Raw page param:', routeQuery.page);
    
    const parsed = {
        client: Array.isArray(routeQuery.client) 
            ? routeQuery.client.filter(c => c !== null).map(c => parseInt(c as string))
            : (routeQuery.client ? [parseInt(routeQuery.client as string)] : []),
        status: Array.isArray(routeQuery.status) 
            ? routeQuery.status.filter(s => s !== null).map(s => parseInt(s as string))
            : (routeQuery.status ? [parseInt(routeQuery.status as string)] : []),
        technician: Array.isArray(routeQuery.technician) 
            ? routeQuery.technician.filter(t => t !== null).map(t => parseInt(t as string))
            : (routeQuery.technician ? [parseInt(routeQuery.technician as string)] : []),
        user: (routeQuery.user as string) || '',
        searchTerm: (routeQuery.searchTerm as string) || '',
        startDate: (routeQuery.startDate as string) || '',
        endDate: (routeQuery.endDate as string) || '',
        page: parseInt((routeQuery.page as string) || '0'),
        size: parseInt((routeQuery.size as string) || '25'),
        sort: parseSortFromUrl(routeQuery.sort as string)
    };
    
    console.debug('Parsed filter:', parsed);
    return parsed;
};

// Build URL params from filter object
const buildUrlFromFilter = (filter: JobListFilter): string => {
    const params = new URLSearchParams();
    
    // Add array parameters
    filter.client.forEach(c => c && params.append('client', c.toString()));
    filter.status.forEach(s => s && params.append('status', s.toString()));
    filter.technician.forEach(t => t && params.append('technician', t.toString()));
    
    // Add single parameters
    if (filter.user) params.set('user', filter.user);
    if (filter.searchTerm) params.set('searchTerm', filter.searchTerm);
    if (filter.startDate) params.set('startDate', filter.startDate);
    if (filter.endDate) params.set('endDate', filter.endDate);
    
    // Add sort parameter - convert KtDatatable sort array back to URL string
    if (filter.sort && filter.sort.length > 0) {
        const sortString = filter.sort.map(sortObj => {
            const [column, direction] = Object.entries(sortObj)[0];
            return direction === 'DESC' ? `-${column}` : column;
        }).join(',');
        params.set('sort', sortString);
    }
    
    // Always include page parameter (even for page 0/1)
    params.set('page', filter.page.toString());
    if (filter.size !== 25) params.set('size', filter.size.toString());
    
    return params.toString();
};

// Debounced URL update
let urlUpdateTimeout: NodeJS.Timeout | null = null;
const updateUrlFromFilter = () => {
    if (urlUpdateTimeout) clearTimeout(urlUpdateTimeout);
    
    urlUpdateTimeout = setTimeout(() => {
        const urlParams = buildUrlFromFilter(currentFilter.value);
        const newUrl = `/job/list${urlParams ? '?' + urlParams : ''}`;
        
        // Update URL without triggering navigation
        router.replace(newUrl);
        
        // Save to Cache service (consistent with store pattern)
        Cache.set('job-list-filter', currentFilter.value);
    }, 300);
};

// Load filter from Cache service as fallback
const loadFilterFromStorage = (): JobListFilter => {
    try {
        const stored = Cache.get('job-list-filter');
        if (stored) {
            return { ...parseUrlToFilter(), ...stored };
        }
    } catch (e) {
        console.warn('Failed to load filter from Cache:', e);
    }
    return parseUrlToFilter();
};

// ===== API INTEGRATION =====

// Convert filter to API parameters
const buildApiParams = (filter: JobListFilter) => {
    const params: any = {
        Page: filter.page,
        Size: filter.size,
        IncludeContact: true,
        ExcludePMRequests: true  // Exclude PM-linked requests from job list
    };
    
    // Add array filters
    if (filter.client.length > 0) params.CustomerNumber = filter.client;
    if (filter.status.length > 0) params.Status = filter.status;
    if (filter.technician.length > 0) params.Owner = filter.technician;
    
    // Add single filters
    if (filter.user) params.Owner = filter.user;
    if (filter.searchTerm) params.SearchTerm = filter.searchTerm;
    if (filter.startDate) params.StartDate = filter.startDate;
    if (filter.endDate) params.EndDate = filter.endDate;
    
    // Add OrderBy parameter for server-side sorting
    if (filter.sort && filter.sort.length > 0) {
        // Convert sort array to comma-separated OrderBy string
        // Example: [{Id: 'ASC'}] -> "Id", [{Id: 'DESC'}] -> "-Id"
        const orderByParts = filter.sort.map(sortObj => {
            const [column, direction] = Object.entries(sortObj)[0];
            return direction === 'DESC' ? `-${column}` : column;
        });
        params.OrderBy = orderByParts.join(',');
    }
    
    return params;
};

// Load data from API using current filter
const loadData = async () => {
    try {
        console.debug('loadData called with currentFilter:', currentFilter.value);
        const params = buildApiParams(currentFilter.value);
        console.debug('API params:', params);
        
        const response = await Api.loadRequests(params);
        console.debug('API response:', response);
        
        // Update data
        rows.value = response.Data || [];
        
        // Update pagination metadata
        if (response.Meta && response.Meta.Total) {
            total.value = response.Meta.Total;
        }
        
        console.debug('Updated rows:', rows.value.length, 'Total:', total.value);
    } catch (error) {
        console.error('Failed to load data:', error);
        rows.value = [];
        total.value = 0;
    }
};

// ===== FILTER UPDATE HANDLERS =====

// Handle datatable pagination updates
const handleDatatableUpdate = (filterUpdate: any) => {
    console.log('Datatable filter update (pagination/sorting):', filterUpdate);
    
    // Create a temporary filter object for URL building (don't update currentFilter yet)
    const tempFilter = { ...currentFilter.value };
    if (filterUpdate.page !== undefined) tempFilter.page = filterUpdate.page;
    if (filterUpdate.size !== undefined) tempFilter.size = filterUpdate.size;
    if (filterUpdate.sort !== undefined) tempFilter.sort = filterUpdate.sort || [];
    if (filterUpdate.search !== undefined) tempFilter.searchTerm = filterUpdate.search;
    
    // Build URL and navigate directly (let route watcher handle the rest)
    const urlParams = buildUrlFromFilter(tempFilter);
    const newUrl = `/job/list${urlParams ? '?' + urlParams : ''}`;
    
    console.log('Navigating to:', newUrl);
    router.replace(newUrl);
};

// Initialize filter from URL or localStorage
const initializeFilter = () => {
    // Priority: URL params > localStorage > defaults
    const urlFilter = parseUrlToFilter();
    const hasUrlParams = window.location.search.length > 0;
    
    if (hasUrlParams) {
        // URL has params, use them
        currentFilter.value = urlFilter;
    } else {
        // No URL params, try localStorage
        currentFilter.value = loadFilterFromStorage();
    }
    
    console.debug('Initialized filter:', currentFilter.value);
};

// ===== LIFECYCLE & WATCHERS =====

// Watch route changes to update filter
watch(() => route.query, (newQuery) => {
    console.debug('=== ROUTE WATCHER TRIGGERED ===');
    console.debug('Route query changed:', newQuery);
    console.debug('Current URL:', window.location.href);
    
    // Parse new filter from URL
    const newFilter = parseUrlToFilter();
    
    // Only update if filter actually changed (avoid infinite loops)
    const currentParams = buildUrlFromFilter(currentFilter.value);
    const newParams = buildUrlFromFilter(newFilter);
    
    console.debug('Current params:', currentParams);
    console.debug('New params:', newParams);
    console.debug('Params equal?', currentParams === newParams);
    console.debug('Current filter page:', currentFilter.value.page);
    console.debug('New filter page:', newFilter.page);
    
    if (currentParams !== newParams) {
        console.debug('✅ Filter changed, updating currentFilter and calling loadData()');
        currentFilter.value = newFilter;
        
        // Update cache with new filter state (including when cleared)
        Cache.set('job-list-filter', currentFilter.value);
        
        loadData();
    } else {
        console.debug('❌ Filter unchanged, skipping update');
    }
}, { immediate: false });

// Initialize on mount
onMounted(() => {
    console.debug('JobList mounted, initializing...');
    initializeFilter();
    loadData();
});

// KtDatatable model definition for Request/Job list
const requestModel = [
    {
        name: "Select",
        label: "Select",
        type: "select",
        width: 60,
        locked: true,
        draggable: false
    },
    {
        name: "Id",
        label: "ID",
        display: true,
        sortable: true
    },
    {
        name: "Contact",
        label: "Client",
        display: true,
        type: "string"
    },
    {
        name: "RequestDetailedDescription",
        label: "Description",
        display: true,
        type: "string"
    },
    {
        name: "TaskDetail",
        label: "Task Detail",
        display: false,
        type: "string"
    },
    {
        name: "CreateDate",
        label: "Created",
        display: true,
        type: "date",
        sortable: true
    },
    {
        name: "DueDate",
        label: "Due Date",
        display: true,
        type: "date",
        sortable: true
    },
    {
        name: "RequestStatus",
        label: "Status",
        display: true,
        type: "string"
    },
    {
        name: "Priority",
        label: "Priority",
        display: true,
        type: "number",
        sortable: true
    },
    {
        name: "Technician",
        label: "Technician",
        display: true,
        type: "string"
    },
    {
        name: "Location",
        label: "Location",
        display: false,
        type: "string"
    },
    {
        name: "RequestType",
        label: "Request Type",
        display: false,
        type: "string"
    },
    {
        name: "CompletionDate",
        label: "Completed",
        display: false,
        type: "date",
        sortable: true
    },
    {
        name: "Progress",
        label: "Progress %",
        display: false,
        type: "number",
        sortable: true
    },
    {
        name: "Project",
        label: "Is Project",
        display: false,
        type: "string"
    },
    {
        name: "Requestor",
        label: "Requestor",
        display: false,
        type: "string"
    },
    {
        name: "EstimatedAmount",
        label: "Estimated Amount",
        display: false,
        type: "number",
        sortable: true
    },
    {
        name: "EstimateNumber",
        label: "Estimate #",
        display: false,
        type: "string"
    },
    {
        name: "TimeEstimate",
        label: "Time Estimate",
        display: false,
        type: "string"
    },
    {
        name: "InvoiceNumber",
        label: "Invoice #",
        display: false,
        type: "string"
    },
    {
        name: "InvoicedOn",
        label: "Invoiced On",
        display: false,
        type: "date",
        sortable: true
    },
    {
        name: "InvoiceTotal",
        label: "Invoice Total",
        display: false,
        type: "number",
        sortable: true
    },
    {
        name: "PaidOn",
        label: "Paid On",
        display: false,
        type: "date",
        sortable: true
    },
    {
        name: "BillingNotes",
        label: "Billing Notes",
        display: false,
        type: "string"
    },
    {
        name: "ServiceReport",
        label: "Service Report",
        display: false,
        type: "string"
    }
] as Array<KtDatatableModelProp>;

// Legacy variables moved to top of script section to avoid duplicates

const editTitle = ref("Edit Request");
const showEdit = ref(false);

const newRecord = () =>
{
    router.push({
        path: "/job/edit/new"
    });
};

const refresh = () =>
{
    loadData();
};

const editRecord = (id) =>
{
    router.push({
        path: "/job/edit/" + id
    });
};

const editTech = (id) => {
    Emitter.emit("open:techForm", id);
};

const editContact = (id) => {
    Emitter.emit("open:clientForm", id);
}

// ===== FILTER BADGE FUNCTIONS =====

// Computed property to check if any filters are active
const hasActiveFilters = computed(() => {
    return currentFilter.value.client.length > 0 ||
           currentFilter.value.technician.length > 0 ||
           currentFilter.value.status.length > 0 ||
           currentFilter.value.searchTerm ||
           currentFilter.value.startDate ||
           currentFilter.value.endDate;
});

// Helper functions to get names for display
const getClientName = (customerNumber: number) => {
    // Find client by CustomerNumber since ClientList is an array
    const client = ClientList.value.find((c: any) => c.CustomerNumber === customerNumber);
    return client?.Company || `Client #${customerNumber}`;
};

const getTechnicianName = (techId: number) => {
    // TechList is a Record/dictionary, access by key
    const tech = TechList.value[techId];
    return tech?.TechnicianName || `Tech #${techId}`;
};

const getStatusName = (statusId: number) => {
    // JobStatusList is a Record/dictionary, access by key
    const status = JobStatusList.value[statusId];
    return status?.Status || `Status #${statusId}`;
};

// Helper function to get Bootstrap badge class based on status
const getStatusBadgeClass = (statusId: number) => {
    const status = JobStatusList.value[statusId];
    const statusName = status?.Status?.toLowerCase() || '';
    
    // Map common status names to Bootstrap badge classes
    if (statusName.includes('completed') || statusName.includes('done') || statusName.includes('finished')) {
        return 'bg-success'; // Green for completed
    } else if (statusName.includes('pending') || statusName.includes('waiting') || statusName.includes('queued')) {
        return 'bg-warning'; // Yellow for pending
    } else if (statusName.includes('progress') || statusName.includes('active') || statusName.includes('working')) {
        return 'bg-primary'; // Blue for in progress
    } else if (statusName.includes('cancelled') || statusName.includes('rejected') || statusName.includes('failed')) {
        return 'bg-danger'; // Red for cancelled/failed
    } else if (statusName.includes('scheduled') || statusName.includes('planned')) {
        return 'bg-info'; // Light blue for scheduled
    } else if (statusName.includes('draft') || statusName.includes('new')) {
        return 'bg-secondary'; // Gray for draft/new
    } else {
        return 'bg-light text-dark'; // Light gray for unknown statuses
    }
};

// Helper function to get Font Awesome icon based on status
const getStatusIcon = (statusId: number) => {
    const status = JobStatusList.value[statusId];
    const statusName = status?.Status?.toLowerCase() || '';
    
    if (statusName.includes('completed') || statusName.includes('done') || statusName.includes('finished')) {
        return 'fas fa-check-circle';
    } else if (statusName.includes('pending') || statusName.includes('waiting') || statusName.includes('queued')) {
        return 'fas fa-clock';
    } else if (statusName.includes('progress') || statusName.includes('active') || statusName.includes('working')) {
        return 'fas fa-spinner fa-spin';
    } else if (statusName.includes('cancelled') || statusName.includes('rejected') || statusName.includes('failed')) {
        return 'fas fa-times-circle';
    } else if (statusName.includes('scheduled') || statusName.includes('planned')) {
        return 'fas fa-calendar-check';
    } else if (statusName.includes('draft') || statusName.includes('new')) {
        return 'fas fa-file';
    } else {
        return 'fas fa-circle';
    }
};

// Helper function to get row background class based on status
const getRowClass = (row: any) => {
    const statusId = row.RequestStatus;
    const status = JobStatusList.value[statusId];
    const statusName = status?.Status?.toLowerCase() || '';
    
    if (statusName.includes('completed') || statusName.includes('done') || statusName.includes('finished')) {
        return 'row-status-completed';
    } else if (statusName.includes('pending') || statusName.includes('waiting') || statusName.includes('queued')) {
        return 'row-status-pending';
    } else if (statusName.includes('progress') || statusName.includes('active') || statusName.includes('working')) {
        return 'row-status-progress';
    } else if (statusName.includes('cancelled') || statusName.includes('rejected') || statusName.includes('failed')) {
        return 'row-status-cancelled';
    } else if (statusName.includes('scheduled') || statusName.includes('planned')) {
        return 'row-status-scheduled';
    } else if (statusName.includes('draft') || statusName.includes('new')) {
        return 'row-status-draft';
    }
    return '';
};

// Helper function to get Bootstrap badge class based on priority
const getPriorityBadgeClass = (priority: number) => {
    // Map priority IDs to badge colors based on your database values
    // 1=Critical, 2=High, 3=Medium, 4=Low, 5=Schedule
    if (priority === 1) return 'bg-danger';      // Critical
    if (priority === 2) return 'bg-warning';     // High
    if (priority === 3) return 'bg-info';        // Medium
    if (priority === 4) return 'bg-secondary';   // Low
    if (priority === 5) return 'bg-primary';     // Schedule
    return 'bg-secondary';
};

const formatDateRange = () => {
    const start = currentFilter.value.startDate;
    const end = currentFilter.value.endDate;
    if (start && end) {
        return `${start} to ${end}`;
    } else if (start) {
        return `From ${start}`;
    } else if (end) {
        return `Until ${end}`;
    }
    return '';
};

// Filter removal functions
const removeClientFilter = (clientId: number) => {
    const newClients = currentFilter.value.client.filter(id => id !== clientId);
    setFilter({ client: newClients });
};

const removeTechnicianFilter = (techId: number) => {
    const newTechs = currentFilter.value.technician.filter(id => id !== techId);
    setFilter({ technician: newTechs });
};

const removeStatusFilter = (statusId: number) => {
    const newStatuses = currentFilter.value.status.filter(id => id !== statusId);
    setFilter({ status: newStatuses });
};

const removeDateFilter = () => {
    setFilter({ startDate: '', endDate: '' });
};

// ===== SELECTION MANAGEMENT =====

const toggleRowSelection = (rowId: number) => {
    const index = selectedRows.value.indexOf(rowId);
    if (index > -1) {
        selectedRows.value.splice(index, 1);
    } else {
        selectedRows.value.push(rowId);
    }
    updateSelectAllState();
};

const toggleSelectAll = () => {
    if (selectAll.value) {
        // Deselect all
        selectedRows.value = [];
        selectAll.value = false;
    } else {
        // Select all on current page
        selectedRows.value = rows.value.map((row: any) => row.Id);
        selectAll.value = true;
    }
};

const updateSelectAllState = () => {
    if (rows.value.length === 0) {
        selectAll.value = false;
        return;
    }
    const allSelected = rows.value.every((row: any) => selectedRows.value.includes(row.Id));
    selectAll.value = allSelected;
};

const clearSelection = () => {
    selectedRows.value = [];
    selectAll.value = false;
};

// ===== BULK ACTIONS =====

const applyBulkAssignTech = async () => {
    if (!bulkAssignTech.value || selectedRows.value.length === 0) return;
    
    // TODO: Load full records, update AssignedTechnician field, and save
    console.log('Bulk assign tech:', bulkAssignTech.value, 'to rows:', selectedRows.value);
    
    showAssignTechModal.value = false;
    clearSelection();
};

const applyBulkDueDate = async () => {
    if (!bulkDueDate.value || selectedRows.value.length === 0) return;
    
    // TODO: Load full records, update DueDate field, and save
    console.log('Bulk set due date:', bulkDueDate.value, 'to rows:', selectedRows.value);
    
    showSetDueDateModal.value = false;
    clearSelection();
};

const applyBulkStatus = async () => {
    if (bulkStatus.value === null || selectedRows.value.length === 0) return;
    
    // TODO: Load full records, update RequestStatus field, and save
    console.log('Bulk set status:', bulkStatus.value, 'to rows:', selectedRows.value);
    
    showSetStatusModal.value = false;
    clearSelection();
};

const applyBulkPriority = async () => {
    if (bulkPriority.value === null || selectedRows.value.length === 0) return;
    
    // TODO: Load full records, update Priority field, and save
    console.log('Bulk set priority:', bulkPriority.value, 'to rows:', selectedRows.value);
    
    showSetPriorityModal.value = false;
    clearSelection();
};

const confirmBulkDelete = () => {
    Alert.confirm(
        `Are you sure you want to delete ${selectedRows.value.length} selected request(s)? This action cannot be undone.`,
        () => {
            // TODO: Implement soft delete when ready
            console.log('Bulk delete rows:', selectedRows.value);
            clearSelection();
        },
        () => {
            // User cancelled
        }
    );
    showDeleteModal.value = false;
};

const clearAllFilters = () => {
    setFilter({
        client: [],
        technician: [],
        status: [],
        searchTerm: '',
        startDate: '',
        endDate: '',
        sort: []
    });
};

// ===== LEGACY FUNCTION REPLACEMENTS =====

// Updated date range change handler (now uses new filter system)
const onDateRangeChange = (range: any) => {
    console.log('Date range changed:', range);
    // This is now handled by the dateRange computed setter above
};

// Updated setFilter for new system - builds URL and navigates (like pagination)
const setFilter = (filterData: any) => {
    console.debug("setFilter (new system):", filterData);
    
    // Create a temporary filter object for URL building (don't update currentFilter yet)
    const tempFilter = { ...currentFilter.value };
    
    // Update temp filter with new data
    if (filterData.client !== undefined) {
        tempFilter.client = Array.isArray(filterData.client) ? filterData.client : (filterData.client ? [filterData.client] : []);
    }
    if (filterData.status !== undefined) {
        tempFilter.status = Array.isArray(filterData.status) ? filterData.status : (filterData.status ? [filterData.status] : []);
    }
    if (filterData.technician !== undefined) {
        tempFilter.technician = Array.isArray(filterData.technician) ? filterData.technician : (filterData.technician ? [filterData.technician] : []);
    }
    if (filterData.user !== undefined) tempFilter.user = filterData.user || '';
    if (filterData.searchTerm !== undefined) tempFilter.searchTerm = filterData.searchTerm || '';
    if (filterData.startDate !== undefined) tempFilter.startDate = filterData.startDate || '';
    if (filterData.endDate !== undefined) tempFilter.endDate = filterData.endDate || '';
    if (filterData.sort !== undefined) tempFilter.sort = filterData.sort || [];
    
    // Reset to first page when filter changes
    tempFilter.page = 0;
    
    // Build URL and navigate directly (let route watcher handle the rest)
    const urlParams = buildUrlFromFilter(tempFilter);
    const newUrl = `/job/list${urlParams ? '?' + urlParams : ''}`;
    
    console.log('setFilter navigating to:', newUrl);
    router.replace(newUrl);
};

// ===== REMOVED OLD COMPLEX FUNCTIONS =====
// All old filter logic has been replaced with the new URL-first system above


</script>

<style scoped>
/* Row shading based on status - applied to td cells */
:deep(.row-status-completed td) {
    background-color: rgba(25, 135, 84, 0.08) !important;
}

:deep(.row-status-completed:hover td) {
    background-color: rgba(25, 135, 84, 0.15) !important;
}

:deep(.row-status-pending td) {
    background-color: rgba(255, 193, 7, 0.08) !important;
}

:deep(.row-status-pending:hover td) {
    background-color: rgba(255, 193, 7, 0.15) !important;
}

:deep(.row-status-progress td) {
    background: linear-gradient(180deg, 
        rgba(13, 110, 253, 0.12) 0%, 
        rgba(13, 110, 253, 0.08) 100%) !important;
    box-shadow: 
        inset 0 1px 0 rgba(255, 255, 255, 0.5),
        0 1px 3px rgba(13, 110, 253, 0.1) !important;
    border-top: 1px solid rgba(255, 255, 255, 0.3) !important;
    position: relative !important;
}

:deep(.row-status-progress td)::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 50%;
    background: linear-gradient(180deg, 
        rgba(255, 255, 255, 0.15) 0%, 
        rgba(255, 255, 255, 0) 100%);
    pointer-events: none;
}

:deep(.row-status-progress:hover td) {
    background: linear-gradient(180deg, 
        rgba(13, 110, 253, 0.18) 0%, 
        rgba(13, 110, 253, 0.12) 100%) !important;
    box-shadow: 
        inset 0 1px 0 rgba(255, 255, 255, 0.6),
        0 2px 4px rgba(13, 110, 253, 0.15) !important;
}

:deep(.row-status-cancelled td) {
    background-color: rgba(220, 53, 69, 0.08) !important;
}

:deep(.row-status-cancelled:hover td) {
    background-color: rgba(220, 53, 69, 0.15) !important;
}

:deep(.row-status-scheduled td) {
    background-color: rgba(13, 202, 240, 0.08) !important;
}

:deep(.row-status-scheduled:hover td) {
    background-color: rgba(13, 202, 240, 0.15) !important;
}

:deep(.row-status-draft td) {
    background-color: rgba(108, 117, 125, 0.08) !important;
}

:deep(.row-status-draft:hover td) {
    background-color: rgba(108, 117, 125, 0.15) !important;
}

/* Datatable link hover effect - blue theme with edit icon badge */
:deep(td a) {
    text-decoration: none;
    color: #333;
    padding: 2px 6px;
    border-radius: 4px;
    border: 1px solid transparent;
    transition: all 0.2s ease-in-out;
    display: inline-block;
    position: relative;
}

:deep(td a:hover) {
    /*
    border: 1px solid rgba(13, 110, 253, 0.3);
    background-color: rgba(13, 110, 253, 0.75);
    */
    background-color: #15486A;
    color: #fff;
}

/* Edit icon badge in top-right corner on hover */
:deep(td a:hover::after) {
    content: '\f044';
    font-family: 'Font Awesome 5 Free';
    font-weight: 900;
    position: absolute;
    top: -6px;
    right: -6px;
    background: #3B9796;
    color: white;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    border: 2px solid white;
}
</style>